import React, { useContext, useEffect, useState } from 'react'
import MainNav from '../../Components/Navbar'
import '../../css/gerenciamento-empresas.css'
import axios from 'axios';
import { getDatabase, onValue, ref, get, child, set, update } from "firebase/database";
import { Button, Col, Container, Form, Row, ListGroup, Card, Accordion, Modal, Spinner } from 'react-bootstrap';
import GlobalContext from '../../Components/GlobalContext';
import $ from 'jquery';
import { firebaseToString, stringToFirebase, toggleRole } from '../../Tools/tools';
import { filter } from 'jszip';
import firebase from 'firebase/compat/app';
import UnnatendedAccess from '../../Components/UnnatendedAccess';


function NewEmpModal({
  showEmpModal,
  closeEmpModal,
  newEmpModalShow,
  companies,
  emp,
  setEmp,
  reportMail,
  setReportMail,
  dep,
  setDep,
  deps,
  setDeps,
  password,
  setPassword,
  passwordConfirm,
  setPasswordConfirm,
  errors,
  editMode,
  addEmp,
  updateEmp,
  resetEmpForm,
  removeItem,
  addDep,
  isFormValid,
  setDepOnlineStatus,
  refreshCompanies
}) {

  const [depOnline, setDepOnline] = useState({});
  const [defaultDepOnline, setDefaultDepOnline] = useState(false);
  const [rollTimeLimitOnline, setRollTimeLimitOnline] = useState(0);
  const [rollTimeLimitOffline, setRollTimeLimitOffline] = useState(0);

  const invalidDepNames = ["rollTimeLimitOffline", "rollTimeLimitOnline", "instrutores", "isCompanyVisible", "ordem"]

  useEffect(() => {

    get(child(ref(db), `/globalSettings`)).then((snapshot) => {
      if (snapshot.exists()) {
        const globalSettings = snapshot.val()

        if (Object.keys(globalSettings).includes("isDeptOnline")) {
          setDefaultDepOnline(globalSettings.isDeptOnline)
        }

        if (Object.keys(globalSettings).includes("rollTimeLimit")) {
          if (Object.keys(globalSettings["rollTimeLimit"]).includes("online")) {
            setRollTimeLimitOnline(globalSettings["rollTimeLimit"]["online"])
          }
          if (Object.keys(globalSettings["rollTimeLimit"]).includes("offline")) {
            setRollTimeLimitOffline(globalSettings["rollTimeLimit"]["offline"])
          }
        }
      }
    })

    getRollTimeLimit();

    if (emp) {

      deps = Object.keys(companies[emp])

      for (const depName of Object.keys(companies[emp])) {
        const fullDep = companies[emp][depName]

        if (fullDep) {
          const depOnline = Object.keys(fullDep).includes('isDeptOnline') ? fullDep['isDeptOnline'] : defaultDepOnline;
          setDepOnline(prev => ({
            ...prev,
            [depName]: depOnline
          }));
        }
      }
    }
  
  }, [deps])

  const db = getDatabase();

  const changeDepStatus = (emp, depName, e) => {
    setDepOnline(prev => ({
      ...prev,
      [depName]: e.target.checked
    }));

    if (!invalidDepNames.includes(depName)) {
      setDepOnlineStatus(emp, depName, e.target.checked)
    }
  }

  const getRollTimeLimit = () => {
    if (companies[emp]) {

      if (Object.keys(companies[emp]).includes('rollTimeLimitOnline')) {
        setRollTimeLimitOnline(companies[emp]['rollTimeLimitOnline'])
      }
      if (Object.keys(companies[emp]).includes('rollTimeLimitOffline')) {
        setRollTimeLimitOffline(companies[emp]['rollTimeLimitOffline'])
      }
    }
  }

  const updateRollTimeLimit = async (e, online = true) => {
    const timeLimit = e.target.value;
    const path = `/companies/${emp}`;

    const key = online ? "rollTimeLimitOnline" : "rollTimeLimitOffline"

    if (online) {
      setRollTimeLimitOnline(timeLimit)
    } else {
      setRollTimeLimitOffline(timeLimit)
    }
    await update(ref(db, path), { [key]: timeLimit })
    refreshCompanies()
  }

  const updateAllDeps = (emp, depName, e) => {
    setDepOnline(prev => {
      const updated = {}

      for (const key in prev) {

        if (!invalidDepNames.includes(key)) {

          setDepOnlineStatus(emp, key, e.target.checked)

          updated[key] = e.target.checked
        }
      }

      return updated
    })
    refreshCompanies()
  }

  return (
    <>
      <Button variant="primary" onClick={showEmpModal} className='btn btn-sm'>
        <i className="bi bi-plus-circle"></i> Nova Empresa
      </Button>

      <Modal show={newEmpModalShow} onHide={closeEmpModal} size='lg'>
        <Modal.Header>
          <Modal.Title>
            {editMode ? "Editar empresa" : "Nova empresa"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className='mx-1'>
              <Row className='mb-3'>
                <Col>
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Label className='fw-semibold'>Empresa</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Nome da empresa"
                        value={emp.toUpperCase()}
                        onChange={(e) => setEmp(e.target.value)}
                        isInvalid={!!errors.emp}
                        disabled={editMode}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.emp}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label className='fw-semibold'>E-mail de representante</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="exemplo@email.com"
                        value={reportMail}
                        onChange={(e) => setReportMail(e.target.value)}
                        isInvalid={!!errors.reportMail}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.reportMail}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label className='fw-semibold'>Senha</Form.Label>
                      <Form.Control
                        type="password"
                        placeholder="Digite a senha"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        isInvalid={!!errors.password}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label className='fw-semibold'>Confirmar Senha</Form.Label>
                      <Form.Control
                        type="password"
                        placeholder="Confirme a senha"
                        value={passwordConfirm}
                        onChange={(e) => setPasswordConfirm(e.target.value)}
                        isInvalid={!!errors.passwordConfirm}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.passwordConfirm}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label className='fw-semibold'>Departamentos</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Adicionar departamento..."
                        value={dep}
                        onChange={(e) => setDep(e.target.value)}
                        isInvalid={!!errors.deps}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.deps}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <div className='d-flex justify-content-end'>
                      <Button variant="primary" onClick={addDep}>
                        + Departamento
                      </Button>
                    </div>

                    <Form.Group className='mb-3'>
                      <Form.Label className='fw-semibold'>Notificações</Form.Label>
                      <Form.Check
                        type="switch"
                        id="custom-switch"
                        label={Object.values(depOnline).every(val => val === true) ? "Empresa Online" : "Empresa Offline"}
                        checked={Object.values(depOnline).every(val => val === true)}
                        onChange={(e) => updateAllDeps(emp, dep, e)}
                      />
                    </Form.Group>
                    <Form.Group className="mb-1">
                      <Form.Label className='fw-semibold'>Tempo máximo para lançamento de presença</Form.Label>

                      <div className='d-flex align-items-center'>
                        <div className='me-2 fw-semibold'>Online</div>
                        <Form.Select onChange={(e) => updateRollTimeLimit(e, true)} value={rollTimeLimitOnline}>
                          <option value="0">Sem limite</option>
                          <option value="10">10 minutos</option>
                          <option value="30">30 minutos</option>
                          <option value="60">1 hora</option>
                          <option value="180">3 horas</option>
                          <option value="360">6 horas</option>
                          <option value="720">12 horas</option>
                        </Form.Select>
                      </div>
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <div className='d-flex align-items-center'>
                        <div className='me-2 fw-semibold'>Offline</div>
                        <Form.Select onChange={(e) => updateRollTimeLimit(e, false)} value={rollTimeLimitOffline}>
                          <option value="0">Sem limite</option>
                          <option value="10">10 minutos</option>
                          <option value="30">30 minutos</option>
                          <option value="60">1 hora</option>
                          <option value="180">3 horas</option>
                          <option value="360">6 horas</option>
                          <option value="720">12 horas</option>
                        </Form.Select>
                      </div>
                    </Form.Group>
                  </Form>
                </Col>

                <Col className='me-2'>

                  <UnnatendedAccess companie={emp} />
                  <span className='fw-semibold'>Departamentos</span>
                  {deps.length === 0 && (
                    <p className='fst-italic text-secondary' style={{ fontSize: "0.8em" }}>
                      Os departamentos adicionados aparecem aqui...
                    </p>
                  )}
                  <ListGroup>
                    {emp && Object.keys(companies[emp]).map((depName, index) => {

                      if (invalidDepNames.includes(depName)) return <></>

                      // console.log(depName)  
                      // console.log(Object.keys(companies[emp]))
                      // console.log(depOnline)

                      return (
                        <ListGroup.Item
                          key={index}
                          className='d-flex justify-content-between align-items-center'
                        >
                          <div>{firebaseToString(depName)}</div>
                          <div className='d-flex'>

                            <Form.Check
                              type="switch"
                              label={depOnline[depName] ? "Online" : "Offline"}
                              className='me-3'
                              checked={depOnline[depName]}
                              onChange={(e) => changeDepStatus(emp, depName, e)}
                            />
                            <i
                              onClick={() => removeItem(index)}
                              className="bi bi-trash3-fill"
                              style={{ cursor: 'pointer' }}
                            ></i>
                          </div>
                        </ListGroup.Item>
                      )
                    })}
                  </ListGroup>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => { resetEmpForm(); closeEmpModal(); }}>
            Cancelar
          </Button>
          {!editMode && (
            <Button variant='success' onClick={addEmp}>
              Adicionar Empresa
            </Button>
          )}
          {editMode && (
            <Button
              variant='success'
              onClick={() => { updateEmp(); closeEmpModal(); }}
              disabled={
                !isFormValid ||
                (reportMail.trim() && !password.trim()) ||
                (password !== passwordConfirm)
              }
            >
              Salvar Alterações
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}

function Empresas() {

  const cadastrarUsuario = async (email, password) => {
    try {
      const data = {
        phoneNumber: '',
        email: email,
        confirmEmail: email,
        password: password,
        sendPassword: false
      };

      const response = await axios.post(`${globalData.apiHost}/newuser`, data, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_BACKEND_SECRET
        }
      });

      const lines = response.data.split('\n');
      const userId = lines[1]?.trim();

      return userId;

    } catch (error) {
      console.error("Erro ao criar usuário:", error);
      alert(`Erro ao criar usuário ${email}. Verifique se já existe.`);
      return null;
    }
  };

  const [dep, setDep] = useState("")
  const [emp, setEmp] = useState("")
  const [reportMail, setReportMail] = useState("")
  const [password, setPassword] = useState("")
  const [passwordConfirm, setPasswordConfirm] = useState("")
  const [deps, setDeps] = useState([])
  const [errors, setErrors] = useState({
    emp: "",
    deps: "",
    password: "",
    passwordConfirm: "",
    reportMail: ""
  });

  const [newEmpModalShow, setNewEmpModalShow] = useState(false);

  const closeEmpModal = () => setNewEmpModalShow(false);
  const showEmpModal = () => setNewEmpModalShow(true);
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    setIsFormValid(validateForm());
  }, [emp, deps, reportMail, password, passwordConfirm]);

  const [editMode, setEditMode] = useState(false)

  const [path, setPath] = useState("")

  const [selectedInstructors, setSelectedInstructors] = useState([])
  const [unselectedInstructors, setUnselectedInstructors] = useState([])

  const [selectedInnieInstructor, setSelectedInnie] = useState({})
  const [selectedOuttieInstructor, setSelectedOuttie] = useState({})

  const [instructors, setInstructors] = useState({})
  const [companies, setCompanies] = useState({})

  const [hiddenEmpVisible, setHiddenEmpVisible] = useState(true)

  const { globalData, setGlobalData } = useContext(GlobalContext);

  const db = getDatabase()

  useEffect(() => {
    // Buscando instrutores
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${globalData.apiHost}/users`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_BACKEND_SECRET
      }
    };

    axios.request(config)
      .then((response) => {
        let i = {}

        for (let a of response.data) {
          i[a.uid] = {
            displayName: a.displayName,
            email: a.email
          }
        }
        setInstructors(i)
      })
      .catch((error) => {
        console.log(error);
      });

    // Buscando Empresas e departamentos 

    refreshCompanies()


    $(document).on("click", ".clickable-dep", function () {
      $(".clickable-dep").removeClass("clickable-dep-active");
      $(this).addClass("clickable-dep-active");

      $(".clickable-prof").removeClass("clickable-prof-active");
      setSelectedOuttie({})
      setSelectedInnie({})
    });

    $(document).on("click", ".clickable-dep-active", function () {
      $(".clickable-dep").removeClass("clickable-dep-active");
      setPath('')
      setSelectedInstructors([])
      setUnselectedInstructors([])
      setSelectedOuttie({})
      setSelectedInnie({})
    });

    $(document).on("click", ".clickable-prof", function () {
      $(".clickable-prof").removeClass("clickable-prof-active");
      $(this).addClass("clickable-prof-active");
    });

    $(document).on("click", ".clickable-prof-active", function () {
      $(".clickable-prof-active").removeClass("clickable-prof-active");
      setSelectedInnie({});
      setSelectedOuttie({});
    });

    return () => {
      $(document).off("click", ".clickable-dep");
      $(document).off("click", ".clickable-prof");
    };
  }, [])

  function refreshCompanies() {
    get(child(ref(db), '/companies')).then((snapshot) => {
      if (snapshot.exists()) {
        setCompanies(snapshot.val())
      } else {
        console.log("No data available");
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  async function setDepOnlineStatus(emp, dep, online = true) {
    const path = `/companies/${emp}/${dep}`
    await update(ref(db, path), { "isDeptOnline": online })
    refreshCompanies()
  }

  function setAllDepsOnlineStatus(emp, deps, online = true) {
    for (const dp of deps) {
      setDepOnlineStatus(emp, dp, online)
    }
  }

  const toggleEmpVisibility = () => {
    const visibility = !hiddenEmpVisible

    setHiddenEmpVisible(visibility)
  }

  const validatePassword = () => {
    const errors = {};

    if (reportMail.trim() && !password.trim()) {
      errors.password = "A senha é obrigatória quando o email está preenchido";
      return { isValid: false, errors };
    }

    if (password.trim() && password.length < 6) {
      errors.password = "A senha deve ter pelo menos 6 caracteres";
      return { isValid: false, errors };
    }

    if (password !== passwordConfirm) {
      errors.passwordConfirm = "As senhas não coincidem";
      return { isValid: false, errors };
    }

    return { isValid: true, errors };
  };
  const validateForm = () => {
    let valid = true;
    let newErrors = { emp: "", deps: "", password: "", passwordConfirm: "" };

    if (!emp.trim()) {
      newErrors.emp = "O nome da empresa é obrigatório.";
      valid = false;
    }

    if (deps.length === 0) {
      newErrors.deps = "Adicione pelo menos um departamento.";
      valid = false;
    }

    const passwordValidation = validatePassword();
    if (!passwordValidation.isValid) {
      Object.assign(newErrors, passwordValidation.errors);
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const addEmp = async () => {
    if (!validateForm()) return;

    const newEmp = {};
    newEmp[emp] = {
      isCompanyVisible: true
    };

    for (let dep of deps) {
      newEmp[emp][dep] = {
        instrutores: []
      };
    }
    try {
      const path = `/companies/${stringToFirebase(emp)}`;
      await set(ref(db, path), newEmp[emp]);
      setCompanies((prevState) => {
        const updatedState = { ...prevState, [emp]: newEmp[emp] };
        return Object.keys(updatedState)
          .sort()
          .reduce((acc, key) => {
            acc[key] = updatedState[key];
            return acc;
          }, {});
      });

      await checkAndCreateUser(reportMail, password);

    } catch (error) {
      console.error("Erro ao adicionar empresa:", error);
    }

    setDep("");
    setEmp("");
    setDeps([]);
    setReportMail("");
    setPassword("");
    setPasswordConfirm("");
    setErrors({ emp: "", deps: "", password: "", passwordConfirm: "" });
  };

  const addDep = () => {
    if (dep.trim()) {
      setDeps([...deps, dep]);
      setDep("");
    }
  };

  const removeItem = (index) => {
    setDeps(deps.filter((_, i) => i !== Number(index)));
  };

  const selectDep = (instrutores, dep, emp) => {
    let selInst = {}
    let unselInst = {}

    Object.entries(instructors).forEach(([key, value], index) => {
      if (instrutores && instrutores.includes(key)) {
        selInst[key] = value
      } else {
        unselInst[key] = value
      }
    })

    setPath(`companies/${emp}/${dep}/instrutores`)
    setSelectedInstructors(selInst)
    setUnselectedInstructors(unselInst)
  }

  const changeEmpVisibility = (companyName, visible = false) => {
    setCompanies(prevState => ({
      ...prevState,
      [companyName]: {
        ...prevState[companyName],
        isCompanyVisible: visible
      }
    }))

    const path = `/companies/${companyName}/isCompanyVisible`

    const updateData = {
      [path]: false
    }

    update(ref(db), updateData)
  }

  const selectInnie = (data) => {
    setSelectedOuttie({})
    setSelectedInnie(data)
  }

  const selectOuttie = (data) => {
    setSelectedOuttie(data)
    setSelectedInnie({})
  }

  const outtieToInnie = () => {
    setSelectedInstructors(prevState => {
      const updatedState = { ...prevState, ...selectedOuttieInstructor };
      updateInstructors(updatedState);
      return updatedState;
    });

    const idToRemove = Object.keys(selectedOuttieInstructor)[0];

    setUnselectedInstructors(prevState => {
      const updated = { ...prevState };
      delete updated[idToRemove];
      return updated;
    });
  };

  const innieToOuttie = () => {
    setUnselectedInstructors(prevState => {
      const updatedState = { ...prevState, ...selectedInnieInstructor };
      return updatedState;
    });

    const idToRemove = Object.keys(selectedInnieInstructor)[0];

    setSelectedInstructors(prevState => {
      const updated = { ...prevState };
      delete updated[idToRemove];

      updateInstructors(updated);

      return updated;
    });
  };

  const startEditingEmp = (emp) => {
    let filtered = Object.keys(companies[emp]).filter(
      (key) => key !== "instrutores"
        && key !== "isCompanyVisible"
        && key !== "rollTimeLimitOffline"
        && key !== "rollTimeLimitOnline"
        && companies[emp][key].isDeptVisible === hiddenEmpVisible
    )
    filtered = filtered.map(item => firebaseToString(item))
    setEmp(emp)
    setDeps(filtered)
    setEditMode(true)
    showEmpModal()
  }

  function compareDepLists(dbDeps, localDeps) {
    dbDeps = dbDeps.filter((val) => val !== "instrutores" && val !== "isCompanyVisible")
    dbDeps = dbDeps.map(item => item.trim().toUpperCase());
    localDeps = localDeps.map(item => item.trim().toUpperCase());

    let remoteOnly = dbDeps.filter(item => !localDeps.includes(item));
    let localOnly = localDeps.filter(item => !dbDeps.includes(item));
    let inBoth = dbDeps.filter(item => localDeps.includes(item));

    return { remoteOnly, localOnly, inBoth };
  }

  const updateEmp = async () => {
    let updateData = {}

    get(child(ref(db), `/companies/${stringToFirebase(emp)}`)).then(async (snapshot) => {
      if (snapshot.exists()) {
        const val = snapshot.val()

        let result = compareDepLists(Object.keys(val), deps)

        for (let remoteDep of result.remoteOnly) {
          updateData[remoteDep] = val[remoteDep]
          updateData[remoteDep]['isDeptVisible'] = false
        }

        for (let localDep of result.localOnly) {
          updateData[localDep] = { isDeptVisible: true, instrutores: [] }
        }

        for (let dep of result.inBoth) {
          updateData[dep] = val[dep]
          updateData[dep]['isDeptVisible'] = true
        }

        const updates = {}
        updates[`/companies/${stringToFirebase(emp)}`] = updateData

        update(ref(db), updates)

        setCompanies(prevState => ({
          ...prevState,
          [emp]: updateData
        }));

        await checkAndCreateUser(reportMail, password);

        resetEmpForm()
      }
    })
  }

  const resetEmpForm = () => {
    setEmp("")
    setDep("")
    setDeps([])
    setReportMail("")
    setPassword("")
    setPasswordConfirm("")
    setEditMode(false)
    setPath("")
    setErrors({ emp: "", deps: "", password: "", passwordConfirm: "" })
  }

  const sortDepInst = (data) => {
    return Object.fromEntries(
      Object.entries(data)
        .filter(([_, value]) => value.displayName) // Remove entries without displayName
        .sort((a, b) => a[1].displayName.localeCompare(b[1].displayName))
    );
  }

  const updateInstructors = (data) => {
    if (Object.entries(data).length > 0) {
      set(ref(db, path), Object.keys(data))
    }
  }

  const checkAndCreateUser = async (email, password) => {
    const existingUser = Object.entries(instructors).find(([_, user]) => user.email === email);

    if (!existingUser) {
      const userId = await cadastrarUsuario(email, password);
      if (userId) {
        toggleRole(true, 'externo', userId, emp);
      }
    } else {
      const userId = existingUser[0];
      toggleRole(true, 'externo', userId, emp);
    }
  };

  function DeleteEmpModal(name) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
      <>
        <i className="bi bi-eye-slash-fill" onClick={handleShow}></i>
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Deletar Empresa</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Você está prestes a deletar a empresa {firebaseToString(name.name)}.<br />
            Ela ficará indisponível e não será possível criar novas chamadas.<br />
            Deseja continuar?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={() => changeEmpVisibility(name.name, false)}>
              Deletar
            </Button>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  function RestoreEmpModal(name) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
      <>
        <i className="bi bi-eye-fill" onClick={handleShow}></i>
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Restaurar Empresa</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Você está prestes a restaurar a empresa {firebaseToString(name.name)}.<br />
            Ela ficará disponível e será possível criar novas chamadas.<br />
            Deseja continuar?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={() => changeEmpVisibility(name.name, true)}>
              Restaurar
            </Button>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  function InstructorList(title, instructors, onClick) {
    const sortedInstructors = sortDepInst(instructors)

    return <Col style={{ maxHeight: "40%", overflow: "auto" }}>
      <h5 className="text-center">{title}</h5>
      <div className="border border-2 rounded">
        <ListGroup variant="flush">
          {Object.entries(sortedInstructors)
            .filter(([_, val]) => val.displayName)
            .map(([key, val], index) => (
              <ListGroup.Item
                key={index}
                className='clickable-prof'
                onClick={() => onClick({ [key]: val })}
              >
                {val.displayName}
              </ListGroup.Item>
            ))}
        </ListGroup>
      </div>
    </Col>
  };

  return (
    <div className=''>
      <MainNav />

      <Container className=''>
        <div className='d-flex align-items-center'>
          <h3 className='py-3 me-3'>Empresas</h3>
          <div>
            <NewEmpModal
              showEmpModal={showEmpModal}
              closeEmpModal={closeEmpModal}
              newEmpModalShow={newEmpModalShow}
              emp={emp}
              setEmp={setEmp}
              reportMail={reportMail}
              setReportMail={setReportMail}
              password={password}
              setPassword={setPassword}
              passwordConfirm={passwordConfirm}
              setPasswordConfirm={setPasswordConfirm}
              dep={dep}
              setDep={setDep}
              deps={deps}
              setDeps={setDeps}
              errors={errors}
              editMode={editMode}
              addEmp={addEmp}
              updateEmp={updateEmp}
              resetEmpForm={resetEmpForm}
              removeItem={removeItem}
              addDep={addDep}
              isFormValid={isFormValid}
              setDepOnlineStatus={setDepOnlineStatus}
              setAllDepsOnlineStatus={setAllDepsOnlineStatus}
              companies={companies}
              refreshCompanies={refreshCompanies}
            />
          </div>
        </div>

        <Row className='' >
          <Col className='' >
            <div className='d-flex justify-content-between align-items-center'>
              <div className=''>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  label="Mostrar deletadas"
                  value={hiddenEmpVisible}
                  onChange={(e) => { toggleEmpVisibility(e) }}
                />
              </div>
            </div>
            {Object.entries(companies).length == 0 &&
              <div className='d-flex justify-content-center align-items-center h-100'>
                <Spinner />
              </div>
            }
            {Object.entries(companies).length > 0 &&
              <Accordion style={{ maxHeight: "40%", overflow: "auto" }}>
                {Object.entries(companies)
                  .filter(([key]) => key !== "id")
                  .map(([key, value], index) => {
                    if (!hiddenEmpVisible || value.isCompanyVisible !== false) {
                      return <Accordion.Item eventKey={String(index)} key={index}>
                        <Accordion.Header className=''>
                          <div
                            className={`emp-list-item ${value.isCompanyVisible === false ? "emp-list-item-restore" : "emp-list-item-delete"
                              } w-100 d-flex justify-content-between align-items-center pe-2`}
                          >
                            <div style={{ color: value.isCompanyVisible === false ? 'gray' : 'black' }}
                              className={value.isCompanyVisible !== false ? 'fw-semibold' : ''}
                            >
                              {value.isCompanyVisible === false && <span>[Deletado]</span>} {firebaseToString(key)}
                            </div>
                            <div>
                              {value.isCompanyVisible !== false && <DeleteEmpModal name={key} />}
                              {value.isCompanyVisible == false && <RestoreEmpModal name={key} />}
                              <i className="bi bi-pencil text-primary ms-3" onClick={() => startEditingEmp(key)}></i>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body style={{ backgroundColor: "#e2e2e2" }}>
                          <ListGroup variant="">
                            {Object.entries(value)
                              .filter(([valKey]) => valKey !== "instrutores"
                                && valKey !== "isCompanyVisible"
                                && valKey !== "rollTimeLimitOffline"
                                && valKey !== "rollTimeLimitOnline")
                              .map(([valKey, valValue]) => {
                                if (!hiddenEmpVisible || valValue.isDeptVisible !== false) {
                                  const instrutores = valValue.instrutores
                                  return (
                                    <ListGroup.Item key={valKey} variant="light" className='clickable-dep' onClick={() => selectDep(instrutores, valKey, key)}>
                                      {firebaseToString(valKey)}
                                    </ListGroup.Item>
                                  )
                                } else return null
                              })}
                          </ListGroup>
                        </Accordion.Body>
                      </Accordion.Item>
                    } else return null
                  })}
              </Accordion>
            }
          </Col>
          {path !== "" &&
            <Col md={6} className=''>
              <>
                <Row className='d-flex justify-content-center h-100'>
                  {InstructorList("Professores disponíveis", unselectedInstructors, selectOuttie)}
                  <Col xs={1} className='d-flex flex-column'>
                    {
                      Object.entries(selectedOuttieInstructor).length > 0 &&
                      <div className='d-flex justify-content-center h-100'>
                        <div className='align-self-center'>
                          <Button onClick={() => { outtieToInnie() }}>
                            <i className="bi bi-arrow-right"></i>
                          </Button>
                        </div>
                      </div>
                    }
                    {
                      Object.entries(selectedInnieInstructor).length > 0 &&
                      <div className='d-flex justify-content-center h-100'>
                        <div className='align-self-center'>
                          <Button onClick={() => { innieToOuttie() }}>
                            <i className="bi bi-arrow-left"></i>
                          </Button>
                        </div>
                      </div>
                    }
                  </Col>
                  {InstructorList("Professores atribuídos", selectedInstructors, selectInnie)}
                </Row>
              </>
            </Col>
          }
        </Row>

      </Container>
    </div>
  )
}

export default Empresas